import React from 'react';
import ReactDOM from 'react-dom';
import { useEffect, useState, useRef } from "react"
import {Container, Row, Col, Card, CardDeck, Jumbotron} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Data.css";
import { Link } from "react-router-dom"
import * as Icon from 'react-bootstrap-icons';
// import {Stack, Button} from '@mui/material';
import { CheckIcon, CheckCircleIcon } from '@heroicons/react/20/solid'
import pdfFile from "../../assets/PDFs/manuscript_ReStud_CondAccept.pdf"
import pptFile from "../../assets/PDFs/MullerVerner_20220330_UMD.pdf"
import dataDta from "../../assets/Credit_Data/MV_credit_data.dta"
import dataExcel from "../../assets/Credit_Data/MV_credit_data.xlsx"
import { Helmet } from 'react-helmet';

window.mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};
  

const Data = () => {
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const isMobile = window.mobileAndTabletCheck();


    const tiers = [
        {
          name: 'Hobby',
          id: 'tier-hobby',
          href: '#',
          priceMonthly: '$19',
          description: "The perfect plan if you're just getting started with our product.",
          features: ['One-time Snapshot', 
                    'Sector Credit Data of 100+ countries', 
                    'Analysis in pdf format',
                    'Allows monitoring risks coming from household and corporate debt',
                    'Ready-to-use and raw data up to the current month (inclusive)',
                    'Highly reliable nowcasts and forecasts of credit flows by sector',
                    'Extensive up-to-date technical documentation outlining data, methods, and benchmarks'],
          featured: false,
        },
        {
          name: 'Enterprise',
          id: 'tier-enterprise',
          href: '#',
          priceMonthly: '$49',
          description: 'Dedicated support and infrastructure for your company.',
          features: ['12 monthly updates', 
                    'Sector Credit Data of 100+ countries', 
                    'Analysis in pdf format',
                    'Allows monitoring risks coming from household and corporate debt',
                    'Ready-to-use and raw data up to the current month (inclusive)',
                    'Highly reliable nowcasts and forecasts of credit flows by sector',
                    'Extensive up-to-date technical documentation outlining data, methods, and benchmarks'],
          featured: true,
        }
    ]

    const data = [
        {
          name: 'Monthly Data',
          id: 'tier-basic',
          href: '#',
          price: { monthly: '$15', annually: '$12' },
          description: 'The most detailed data for monthly analysis',
          features: ['100+ countries', 'Data covers 1900 to 2020'],
        },
        {
          name: 'Quarterly Data',
          id: 'tier-essential',
          href: '#',
          price: { monthly: '$30', annually: '$24' },
          description: 'Better insights for quarterly analysis.',
          features: [
            '100+ countries',
            'Data covers 1900 to 2020',
          ],
        },
        {
          name: 'Yearly Data',
          id: 'tier-growth',
          href: '#',
          price: { monthly: '$60', annually: '$48' },
          description: 'Everything necessary to get started.',
          features: [
            '100+ countries',
            'Data covers 1900 to 2020',
          ],
        },
      ]

    



    const scrollTo1 = () => {
        ref1.current.scrollIntoView({behavior: 'smooth'});
    };

    const scrollTo2 = () => {
        ref2.current.scrollIntoView({behavior: 'smooth'});
    };

    const highlight = (id) => {
        document.getElementById(id).animate([
            // keyframes
            { backgroundColor: '#F9E1C6' },
            { backgroundColor: 'transparent' }
          ], {
            // timing options
            duration: 1000,
            iterations: 1
          })
    }

    const handleClick1 = event => {
        // 👇️ toggle shown state
        setShow1(current => !current);
    
        // 👇️ or simply set it to true
        // setIsShown(true);
      };

    const handleClick2 = event => {
        // 👇️ toggle shown state
        setShow2(current => !current);
    
        // 👇️ or simply set it to true
        // setIsShown(true);
      };
    
    return (
        <Container className="data dark:bg-gray-900">
            <Container className = "data-top dark:text-gray-100">
            <Helmet>
                <title>Data | Global Credit Project</title>
            </Helmet>
                <p className="text-left mt-1 border-l-2 border-blue-800 px-3 text-base mx-auto max-w-screen-xl">
                    The data provided by the Global Credit Project is the result of a multi-year effort to collect and harmonize the most detailed possible information credit markets around the globe. It draws on more than 600 individual sources, many of which were digitized for the first time. On this page, we provide these historical data series for free under the Terms of Use and License Terms outlined below. Integrating all or parts of these data for the purpose of selling them is strictly forbidden.
                    <br/> <br/>
                    The current version of the database covers information on total credit for 188 advanced and emerging economies for the period 1910-2014. Sectoral data for 117 countries starts 1940. With these data, it is possible for the first time to measure how much credit flows to different sectors in the economy on a cross-country basis. The data cover all major financial markets and consistently above 90% of world GDP.  If you are interested in how these data were constructed, please consult the research page. 
                </p>

                <div class="gap-16 items-start py-2 px-2 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-2 lg:px-6">

                    <div class="font-light mt-4 text-gray-500 sm:text-lg dark:text-gray-400">


                        <h2 className="text-2xl font-bold tracking-tight">Historical Data</h2>
                        <p className='text-left font-light'>The historical data covering the years 1940 - 2014 are made available free of charge under the terms of use and license terms below. All values are outstanding amounts of credit in millions of current national currency. Letter names stand for ISIC Rev. 4 sector names (e.g., "C" for manufacturing); see the <a href="https://unstats.un.org/unsd/publication/seriesm/seriesm_4rev4e.pdf" target="_blank">United Nations guide on the International Standard Industrial Classification of All Economic Activities</a> for reference. We plan to continuously improve these statistics, so we advise users to reference the exact date they downloaded the database.</p>

                        <p className="mt-6 font-light">
                            <a href={process.env.PUBLIC_URL + "/MV_credit_data.dta"} target='_blank' rel="noreferrer" download='MV_credit_data.dta' className='block rounded bg-gray-50 dark:bg-gray-100 dark:hover:bg-gray-300 border-1 no-underline mx-auto my-2 b-1 xs:w-[200px] md:w-[400px] px-2 py-2 text-base font-semibold text-gray-900 shadow-md ring-3 ring-gray-600 hover:bg-gray-100'>Download data (dta)</a>
                            <a href={process.env.PUBLIC_URL + "/MV_credit_data.xlsx"} target='_blank' rel="noreferrer" download='MV_credit_data.xlsx' className='block rounded bg-gray-50 dark:bg-gray-100 dark:hover:bg-gray-300 no-underline mx-auto my-2 b-1 xs:w-[200px] md:w-[400px] px-2 py-2 text-base font-semibold text-gray-900 shadow-md ring-3 ring-gray-600 hover:bg-gray-100'>Download data (Excel)</a>
                        </p>

                        <p className="mt-6 text-left font-light">
                        <b>When using these data, please cite the following paper:</b>
                        <br/>
                        <br/>
                        Müller, Karsten and Verner, Emil, Credit Allocation and Macroeconomic Fluctuations (2023). Available at 
                        SSRN:  <a target='_blank' rel="noreferrer" href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3781981">https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3781981</a> or <a target='_blank' rel="noreferrer" href="http://dx.doi.org/10.2139/ssrn.3781981">http://dx.doi.org/10.2139/ssrn.3781981</a>
                        <br/>
                        <br/>
                        <cite>
                            @article{'{'}MuellerVerner2023,<br/>
                            title={'{'}Credit Allocation and Macroeconomic Fluctuations{'}'},<br/>
                            author={'{'}Karsten Müller and Emil Verner{'}'},<br/>
                            journal={'{'}Available at SSRN: https://ssrn.com/abstract=3781981{'}'},<br/>
                            year={'{'}2023{'}'}<br/>
                            {'}'}
                        </cite>
                        </p>


                        <div className="mt-2">
                            <h2 className="text-2xl font-bold tracking-tight">Documentation</h2>
                            <p className="mt-6 text-left font-light">
                                For methodological details, the paper "Credit Allocation and Macroeconomic Fluctuations" by Karsten Müller and Emil Verner documents the sources and approach we used in constructing these data. The paper and accompanying data appendix also acknowledge the support we received from research assistants and colleagues. You can find these documents on the research page. 
								<br/>
								<br/>
								Interested in the precise underlying data series for a particular country? Please feel free to <a href="mailto:globalcreditproject@gmail.com">contact us</a>.
                            </p>
                        </div>


                        <div className="mt-2">
                            <h2 className="text-2xl font-bold tracking-tight">Acknowledgments</h2>
                            <p className="mt-6 text-left font-light">
                                This dataset was developed over many years with the financial support of the Governor Woods Foundation, the Institute for New Economic Thinking, and an NUS PYP Start-Up Grant (A-0003319-01-00). We would also like to thank the institutions where we have conducted our research. 
                            </p>
                        </div>       
                        <div className="mt-2">
                            <h2 className="text-2xl font-bold tracking-tight">Terms of Use and License Terms</h2>
                            <p className="mt-6 text-left font-light">
                                We grant every user at no cost a license to use and/or share the licensed material, in whole or in part, provided that it is for non-commercial (e.g., academic) purposes, provided that our dataset is properly attributed and cited to credit the authors, and provided that it may only be shared under identical license terms. Commercial data providers are thus strictly forbidden to integrate all or parts of the dataset into their services and/or resell the data.
                                <br/><br/>
                                All users of this work agree to the terms of a Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International License. 
                                <br/><br/>
                                <a>See here for the <Link to='/license'>full license terms</Link>.</a>
                                <br/><br/>
                                To comply with the attribution requirement in the license, whenever it is used the dataset must be cited as outlined above.

                            </p>
                        </div>
                    </div>
                    <div class="gap-4 mt-4 self-start">
                        <h3 className="text-left text-xl">Resources</h3>
                        
                        <h2 className="text-left text-base">Paper: Credit Allocation and Macroeconomic Fluctuations</h2>
                        <p className="text-left text-sm">
                        <a href={process.env.PUBLIC_URL + "/manuscript_ReStud_CondAccept.pdf"} target='_blank' rel="noreferrer">Download Paper</a>
                        <br />
                        <a>Download data appendix</a>
                        </p>
                        {!isMobile &&
                        <embed className="h-[500px] w-full" src={process.env.PUBLIC_URL + "/manuscript_ReStud_CondAccept.pdf"} type="application/pdf"></embed>
                        }   
                    </div>
                </div>
            </Container>


        </Container>
    ); 
}

const Download = (props) => {
    const data = props.data

    return (
        <div className="mt-10 flow-root">
            <div className="isolate -mt-16 grid max-w-sm grid-cols-1 gap-y-16 divide-y divide-gray-100 dark:divide-gray-600 sm:mx-auto lg:-mx-8 lg:mt-0 lg:max-w-none lg:grid-cols-3 lg:divide-x lg:divide-y-0 xl:-mx-4">
            {data.map((type) => (
                <div key={type.id} className="pt-16 lg:px-8 lg:pt-0 xl:px-14">
                <h3 id={type.id} className="text-lg font-semibold leading-7">
                    {type.name}
                </h3>
                <p className="mt-6 flex items-baseline gap-x-1">
                    <span className="text-5xl font-bold tracking-tight">Free</span>
                    {/* <span className="text-5xl font-bold tracking-tight text-gray-900">{type.price.monthly}</span>
                    <span className="text-sm font-semibold leading-6 text-gray-600">/month</span> */}
                </p>
                {/* <p className="mt-3 text-sm leading-6 text-gray-500">{type.price.annually} per month if paid annually</p> */}
                <p className="mt-3 text-sm leading-6 text-gray-500 dark:text-gray-200">under the terms of use and license terms below</p>

                <a
                    href={type.href}
                    aria-describedby={type.id}
                    className="mt-10 block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                    Download
                </a>
                <p className="mt-10 text-sm font-semibold leading-6">{type.description}</p>
                <ul role="list" className="mt-6 space-y-3 text-sm leading-6 text-gray-600 dark:text-gray-200">
                    {type.features.map((feature) => (
                    <li key={feature} className="flex gap-x-3">
                        <CheckCircleIcon className="h-6 w-5 flex-none text-indigo-600" aria-hidden="true" />
                        {feature}
                    </li>
                    ))}
                </ul>
                </div>
            ))}
            </div>
        </div>
    )
}

const Pricing = (props) => {
    const tiers = props.tiers;

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    return (
        <div className="relative isolate px-6 py-5 sm:py-32 lg:px-8">
            <div className="absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl" aria-hidden="true">
                <div
                className="mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
                style={{
                    clipPath:
                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                }}
                />
            </div>
            <div className="mx-auto max-w-2xl text-center lg:max-w-4xl">
                <h2 className="text-md font-semibold leading-3 text-indigo-600">Monthly Real-time Data</h2>
                {/* <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                The right price for you, whoever you are
                </p> */}
            </div>
            {/* <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600">
                Qui iusto aut est earum eos quae. Eligendi est at nam aliquid ad quo reprehenderit in aliquid fugiat dolorum
                voluptatibus.
            </p> */}
            <div className="mx-auto mt-16 grid max-w-lg grid-cols-1 items-center gap-y-6 sm:mt-20 sm:gap-y-0 lg:max-w-4xl lg:grid-cols-2">
                {tiers.map((tier, tierIdx) => (
                <div
                    key={tier.id}
                    className={classNames(
                    tier.featured ? 'relative bg-gray-900 shadow-2xl' : 'bg-white/60 dark:bg-gray-200 sm:mx-8 lg:mx-0',
                    tier.featured
                        ? ''
                        : tierIdx === 0
                        ? 'rounded-t-3xl sm:rounded-b-none lg:rounded-tr-none lg:rounded-bl-3xl'
                        : 'sm:rounded-t-none lg:rounded-tr-3xl lg:rounded-bl-none',
                    'rounded-3xl p-8 ring-1 ring-gray-900/10 sm:p-10'
                    )}
                >
                    <h3
                    id={tier.id}
                    className={classNames(
                        tier.featured ? 'text-indigo-400' : 'text-indigo-600',
                        'text-base font-semibold leading-7'
                    )}
                    >
                    {tier.name}
                    </h3>
                    <p className="mt-4 flex items-baseline gap-x-2">
                    <span
                        className={classNames(
                        tier.featured ? 'text-white' : 'text-gray-900',
                        'text-5xl font-bold tracking-tight'
                        )}
                    >
                        {tier.priceMonthly}
                    </span>
                    <span className={classNames(tier.featured ? 'text-gray-400' : 'text-gray-500', 'text-base')}>/month</span>
                    </p>
                    <p className={classNames(tier.featured ? 'text-gray-300' : 'text-gray-600', 'mt-6 text-base leading-7')}>
                    {tier.description}
                    </p>
                    <ul
                    role="list"
                    className={classNames(
                        tier.featured ? 'text-gray-300' : 'text-gray-600',
                        'mt-8 space-y-3 text-sm leading-6 sm:mt-10'
                    )}
                    >
                    {tier.features.map((feature) => (
                        <li key={feature} className="flex gap-x-3 text-left">
                        <CheckIcon
                            className={classNames(tier.featured ? 'text-indigo-400' : 'text-indigo-600', 'h-6 w-5 flex-none')}
                            aria-hidden="true"
                        />
                        {feature}
                        </li>
                    ))}
                    </ul>
                    <a
                    href={tier.href}
                    aria-describedby={tier.id}
                    className={classNames(
                        tier.featured
                        ? 'bg-indigo-500 text-white shadow-sm hover:bg-indigo-400 focus-visible:outline-indigo-500'
                        : 'text-indigo-600 ring-1 ring-inset ring-indigo-200 hover:ring-indigo-300 focus-visible:outline-indigo-600',
                        'mt-8 block rounded-md py-2.5 px-3.5 text-center text-sm font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10'
                    )}
                    >
                    Get started today
                    </a>
                </div>
                ))}
            </div>
        </div>
    )
}

export default Data



